<glxy-empty-state>
  <glxy-empty-state-title>
    <br />
    <span> {{ 'COMMON.PAGE_NOT_FOUND' | translate }} </span>
  </glxy-empty-state-title>
  <p>{{ 'COMMON.INTEGRATION_NOT_EXIST' | translate }}</p>
  <glxy-empty-state-actions>
    <ng-container>
      <a mat-flat-button color="primary" [routerLink]="routeLink$ | async" [queryParams]="{ tab: 0 }">
        {{ 'COMMON.BACK_TO_INTEGRATIONS' | translate }}
      </a>
    </ng-container>
  </glxy-empty-state-actions>
</glxy-empty-state>
